import { Component, Output, EventEmitter, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { User, HouseUser } from '../profile.model';
import { FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { ProfileService } from '../profile.service';
import { Constants } from '../../../core/services/constants';
import { GeneralService } from '../../../shared/services/general.service';
import { stringify } from '@angular/compiler/src/util';
import { SessionStateService } from '../../../core/services/session-state.service';

@Component({
  selector: 'app-new-user-dialog',
  templateUrl: './new-user-dialog.component.html',
  styleUrls: ['./new-user-dialog.component.scss']
})
export class NewUserDialogComponent implements OnInit {
  @Output() action: EventEmitter<boolean> = new EventEmitter<boolean>();
  isLoggedAdmin: boolean;
  seeNewPasswordConfirm: boolean;
  seeNewPassword: boolean;
  isEdit: boolean;
  houseUser: HouseUser;
  addExistingUserForm: FormGroup;
  addNewUserForm: FormGroup;
  isAdmin = true;
  statusMessage: String;
  newPasswordInputError: Boolean = false;
  newPasswordError: Boolean = false;
  emailError: Boolean = false;
  pkid: string;
  mobilePhone: string;
  adminMessage: string;
  email: string;
  firstName: string;
  lastName: string;
  language: string;
  loading = false;
  activeView = 'existing';
  languages: Array<[string, string]> = [['PT', 'Portuguese'], ['ES', 'Spanish'], ['EN', 'English']];
  permissionsMode = false;
  errorMessage: string;

  ngOnInit(): void {


    this.addExistingUserForm = new FormGroup({
      email: new FormControl(this.email, [Validators.required, Validators.email]),
    });

    this.addNewUserForm = new FormGroup({
      firstName: new FormControl(this.firstName, Validators.required),
      lastName: new FormControl(this.lastName, Validators.required),
      email: new FormControl(this.email, [Validators.required, Validators.email]),
      language: new FormControl(this.language, Validators.required)
    });

  }

  constructor(
    public dialogRef: MatDialogRef<NewUserDialogComponent>,
    private profileService: ProfileService,
    private generalService: GeneralService,
    private sessionStateService: SessionStateService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    /*this.pkid = data.pkid;
    this.isEdit = true;
    this.user = data.user;
    this.mobilePhone = data.mobilePhone;
    this.isLoggedAdmin = data.isLoggedAdmin;*/
  }

  toggle(s: string) {
    if (s !== this.activeView) {
      this.activeView = s;
    }
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  onNextNew(f: NgForm) {
    this.houseUser = new HouseUser(this.sessionStateService.getHouse().houseId, 'User', false, false, false,
      f.value.firstName,
      f.value.lastName,
      f.value.email,
      f.value.language);
    this.permissionsMode = true;
  }

  // onNextExisting(f: NgForm) {
  //   console.log(f.value);
  //   this.houseUser = new HouseUser(this.sessionStateService.getHouse().houseId, 'User', false, false,
  //     f.value.firstName,
  //     f.value.lastName,
  //     f.value.email,
  //     f.value.language);
  //   console.log(this.houseUser);
  //   this.permissionsMode = true;
  // }
  cleanForm(): void {
  }

  onEmitHouseUser(houseUser?) {
    if (houseUser) {
      this.loading = true;
      this.profileService.addUser(this.houseUser).finally(
        () => {
          this.loading = false;
        }
      )
        .subscribe(
          res => {
            this.action.emit(true);
            this.onCloseDialog();
            this.errorMessage = '';
        },
          err => {
            // console.log('error', err);
            this.errorMessage =  err.message;
            this.loading = false;
            }
           );

    } else {
      this.permissionsMode = false;
      this.errorMessage = '';
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/entities/profile/new-user-dialog/new-user-dialog.component.ts